const defaultCustomUIName = 'haltadefinizione'
const configuration = {
  haltadefinizione: {
    analyticsCustomerCode: 'haltadefinizione',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  brera: {
    analyticsCustomerCode: 'brera',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  ff2020: {
    analyticsCustomerCode: 'haltadefinizione',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  genericExternal: {
    analyticsCustomerCode: 'haltadefinizione',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  sanRaffaele: {
    analyticsCustomerCode: 'sanraffaele',
    sendInternalAnalytics: true,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  pololombardia: {
    analyticsCustomerCode: 'pololombardia',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  gnaabarberini: {
    analyticsCustomerCode: 'gnaabarberini',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  fabrizioferrari: {
    analyticsCustomerCode: 'fabrizioferrari',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  fondazionevignola: {
    analyticsCustomerCode: 'fondazionevignola',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  pierluigisterpi: {
    analyticsCustomerCode: 'pierluigisterpi',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  archiviostatomodena: {
    analyticsCustomerCode: 'archiviostatomodena',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  estense: {
    analyticsCustomerCode: 'estense',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  galleriaaccademiafirenze: {
    analyticsCustomerCode: 'galleriaaccademiafirenze',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  galleriaborghese: {
    analyticsCustomerCode: 'galleriaborghese',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  bargellomusei: {
    analyticsCustomerCode: 'bargellomusei',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  asmo: {
    analyticsCustomerCode: 'asmo',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: false,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  Uffizi: {
    analyticsCustomerCode: 'Uffizi',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  polotoscana: {
    analyticsCustomerCode: 'polotoscana',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  ballester: {
    analyticsCustomerCode: 'ballester',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  scrovegni: {
    analyticsCustomerCode: 'scrovegni',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  arcidiocesitorino: {
    analyticsCustomerCode: 'arcidiocesitorino',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  enjoymuseum: {
    analyticsCustomerCode: 'enjoymuseum',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: false,
    showLogoInFullScreen: true,
    hideToolbar: true
  },
  santamariadellascala: {
    analyticsCustomerCode: 'santamariadellascala',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: true,
    hideToolbar: false
  },
  open: {
    analyticsCustomerCode: 'open',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: true,
    showLogoInFullScreen: false,
    hideToolbar: false
  },
  culturatoscana: {
    analyticsCustomerCode: 'culturatoscana',
    sendInternalAnalytics: false,
    showCreditsInsteadOfSimpleLogo: false,
    showLogoInFullScreen: false,
    hideToolbar: false
  }
}

export default {
  getConfigurationFor: function (customUIName, propertyName) {
    let customConfiguration = configuration[customUIName] || configuration[defaultCustomUIName]

    let value = customConfiguration[propertyName]
    return value
  }
}
